import { openDB, DBSchema, IDBPDatabase, deleteDB } from 'idb';
import {AddressBooks, AgentStateResponse, DirectoryEntities, DirectoryResponse, SkillEvent} from "@nice-ccf/common-sdk";
import { IndexDBStoreNames } from './enum/indexDB-store-names';
import { IndexDBKeyNames } from './enum/indexDB-key-names';

export interface storeSchema extends DBSchema {
  'Directory':  {
    key: DirectoryEntities | IndexDBKeyNames.DIRECTORY_SEARCH_RESPONSE;
    value: Array<AgentStateResponse | SkillEvent | AddressBooks> | DirectoryResponse;
  };
}

let db: IDBPDatabase<storeSchema>;
const DB_NAME = "nice-cxone-ccf", DB_VERSION = 1;

/**
 * Used to get the indexDB instance
 * @example -
 * ```
 * const db = dbInstance();
 * ```
 */
export const dbInstance = async() => {
  if(!db){
    db = await openDB<storeSchema>(DB_NAME, DB_VERSION,
    {
      /**
       * callback to upgrade the db once instantiated 
       * @param db - db instance
       * @example -
       */
      upgrade(db) {
        Object.values(IndexDBStoreNames).forEach(storeName => {
          if(!db.objectStoreNames.contains(storeName)){
            db.createObjectStore(storeName);
          }
        })
      }
    });
  }
    return db
}

/**
 * Used to delete the index db instance
 * @example-
 * ```
 * deleteDbInstance();
 * ```
 */
export const deleteDbInstance = async() => {
  await deleteDB(DB_NAME);
}

/**
 * Used to clear the particular store from the indexDB
 * @param indexDBstoreName - store name which needs to be cleared out
 * @example -
 * ```
 * await clearIndexDbStore("Directory");
 * ```
 */
export const clearIndexDbStore = async(indexDBstoreName: IndexDBStoreNames) => {
  const currentDb = db || await dbInstance();
  await currentDb.clear(indexDBstoreName);
}
